<template>
<div class="chapter">
<div class="inner_page">
<p class="tocm"> </p>
<p class="tocm1"><a href="#/OEBPS/ded">Begin Reading</a></p>
<p class="tocm1"><span href="#/OEBPS/toc" title="Link target outside of Sample">Table of Contents</span></p>
<p class="tocm1"><span href="#/OEBPS/ata" title="Link target outside of Sample">About the Author</span></p>
<p class="tocm1"><span href="#/OEBPS/cop" title="Link target outside of Sample">Copyright Page</span></p>
<p class="tocm1"> </p>
<p class="tocm"><strong>Thank you for buying this</strong></p>
<p class="tocm"><strong>St. Martin’s Press ebook.</strong></p>
<p class="tocm"> </p>
<p class="tocm">To receive special offers, bonus content,</p>
<p class="tocm">and info on new releases and other great reads,</p>
<p class="tocm">sign up for our newsletters.</p>
<p class="tocm"> </p>
<p class="tit" id="newsa"><a href="http://us.macmillan.com/newslettersignup?utm_source=ebook&amp;utm_medium=adcard&amp;utm_term=ebookreaders&amp;utm_content=martinebailey_newslettersignup_macdotcom&amp;utm_campaign=9781466860728" target="_blank"><img alt="image" height="67" src="OEBPS/images/NewsletterSignup.jpg" width="112"/></a></p>
<p class="tocm">Or visit us online at</p>
<p class="tocm"><a href="http://us.macmillan.com/newslettersignup?utm_source=ebook&amp;utm_medium=adcard&amp;utm_term=ebookreaders&amp;utm_content=martinebailey_newslettersignup_macdotcom&amp;utm_campaign=9781466860728" target="_blank">us.macmillan.com/newslettersignup</a></p>
<p class="tocm"> </p>
<p class="tocm">For email updates on the author, click <a href="http://us.macmillan.com/authoralerts?authorName=martinebailey&amp;authorRefId=101642567&amp;utm_source=ebook&amp;utm_medium=adcard&amp;utm_term=ebookreaders&amp;utm_content=martinebailey_authoralertsignup_macdotcom&amp;utm_campaign=9781466860728" target="_blank">here</a>.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// mini_toc.vue?74852052